/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGetCommentsQueryResponse, FilesControllerGetCommentsPathParams, FilesControllerGetCommentsQueryParams } from "../../models/filesController/FilesControllerGetComments";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { filesControllerGetComments } from "../../clients/filesService/filesControllerGetComments";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const filesControllerGetCommentsQueryKey = (id: FilesControllerGetCommentsPathParams["id"], params: FilesControllerGetCommentsQueryParams = {}) => [{
  url: '/api/v1/files/:id/comments',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type FilesControllerGetCommentsQueryKey = ReturnType<typeof filesControllerGetCommentsQueryKey>;
export function filesControllerGetCommentsQueryOptions(id: FilesControllerGetCommentsPathParams["id"], params?: FilesControllerGetCommentsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = filesControllerGetCommentsQueryKey(id, params);
  return queryOptions<FilesControllerGetCommentsQueryResponse, ResponseErrorConfig<Error>, FilesControllerGetCommentsQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return filesControllerGetComments(id, params, config);
    }
  });
}

/**
 * @description Returns Liveblocks comments for the file, split into free-standing (page-anchored) and review (question-anchored) groups. Resolved threads are excluded. Pass checklistAppId to scope review comments to a single application.
 * @summary Get file comments for export
 * {@link /api/v1/files/:id/comments}
 */
export function useFilesControllerGetComments<TData = FilesControllerGetCommentsQueryResponse, TQueryData = FilesControllerGetCommentsQueryResponse, TQueryKey extends QueryKey = FilesControllerGetCommentsQueryKey>(id: FilesControllerGetCommentsPathParams["id"], params?: FilesControllerGetCommentsQueryParams, options: {
  query?: Partial<QueryObserverOptions<FilesControllerGetCommentsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? filesControllerGetCommentsQueryKey(id, params);
  const query = useQuery({
    ...filesControllerGetCommentsQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}